import { Form, Input } from 'antd';
import React, { FC } from 'react';
import { ISearchData } from 'shared/types/rvd.types';
import { SelectOptions } from '../..';
import style from './index.module.scss';

type TProps = {
  onSearch: (data: string, key: keyof ISearchData) => void;
};

const Fio: FC<TProps> = ({ onSearch }) => {
  return (
    <Form.Item name={SelectOptions.FIO_OPTION} className={style.searchInput}>
      <Input.Search placeholder="Поиск сотрудника по ФИО" allowClear onSearch={val => onSearch(val, 'fio')} />
    </Form.Item>
  );
};

export default Fio;
